module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/icon-shooting.0ec1c65f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/icon-shooting.png
// module id = 2841
// module chunks = 11